
/**
 * Extracted static data for car makes, logos, models, years and engine types
 * to keep logic clean and improve reusability.
 */

export const carMakes = [
  'Skoda', // Moved to first position
  'Toyota', 'Honda', 'Hyundai', 'Kia', 'Mazda', 'Nissan', 'Mercedes-Benz', 'BMW', 'Audi', 'Volkswagen',
  'Ford', 'Chevrolet', 'Jeep', 'Dodge', 'Ram', 'Subaru', 'Lexus', 'Acura', 'Infiniti', 'Genesis',
  'Tesla', 'Volvo', 'Land Rover', 'Jaguar', 'Porsche', 'Ferrari', 'Lamborghini', 'Maserati', 'Bentley',
  'Cadillac', 'Lincoln', 'Buick', 'GMC', 'Chrysler', 'Mitsubishi', 'Mini', 'Alfa Romeo', 'Fiat',
  // Add new makes
  'Opel', 'Seat', 'Peugeot', 'Citroen'
];

export const carLogos: Record<string, string> = {
  'Toyota': 'https://www.carlogos.org/car-logos/toyota-logo.png',
  'Honda': 'https://www.carlogos.org/car-logos/honda-logo.png',
  'Hyundai': 'https://www.carlogos.org/car-logos/hyundai-logo.png',
  'Kia': 'https://www.carlogos.org/car-logos/kia-logo.png',
  'Mazda': 'https://www.carlogos.org/car-logos/mazda-logo.png',
  'Nissan': 'https://www.carlogos.org/car-logos/nissan-logo.png',
  'Mercedes-Benz': 'https://www.carlogos.org/car-logos/mercedes-benz-logo.png',
  'BMW': 'https://www.carlogos.org/car-logos/bmw-logo.png',
  'Audi': 'https://www.carlogos.org/car-logos/audi-logo.png',
  'Volkswagen': 'https://www.carlogos.org/car-logos/volkswagen-logo.png',
  'Ford': 'https://www.carlogos.org/car-logos/ford-logo.png',
  'Chevrolet': 'https://www.carlogos.org/car-logos/chevrolet-logo.png',
  'Jeep': 'https://www.carlogos.org/car-logos/jeep-logo.png',
  'Dodge': 'https://www.carlogos.org/car-logos/dodge-logo.png',
  'Ram': 'https://www.carlogos.org/car-logos/ram-logo.png',
  'Subaru': 'https://www.carlogos.org/car-logos/subaru-logo.png',
  'Lexus': 'https://www.carlogos.org/car-logos/lexus-logo.png',
  'Acura': 'https://www.carlogos.org/car-logos/acura-logo.png',
  'Infiniti': 'https://www.carlogos.org/car-logos/infiniti-logo.png',
  'Genesis': 'https://www.carlogos.org/car-logos/genesis-logo.png',
  'Tesla': 'https://www.carlogos.org/car-logos/tesla-logo.png',
  'Volvo': 'https://www.carlogos.org/car-logos/volvo-logo.png',
  'Land Rover': 'https://www.carlogos.org/car-logos/land-rover-logo.png',
  'Jaguar': 'https://www.carlogos.org/car-logos/jaguar-logo.png',
  'Porsche': 'https://www.carlogos.org/car-logos/porsche-logo.png',
  'Ferrari': 'https://www.carlogos.org/car-logos/ferrari-logo.png',
  'Lamborghini': 'https://www.carlogos.org/car-logos/lamborghini-logo.png',
  'Maserati': 'https://www.carlogos.org/car-logos/maserati-logo.png',
  'Bentley': 'https://www.carlogos.org/car-logos/bentley-logo.png',
  'Cadillac': 'https://www.carlogos.org/car-logos/cadillac-logo.png',
  'Lincoln': 'https://www.carlogos.org/car-logos/lincoln-logo.png',
  'Buick': 'https://www.carlogos.org/car-logos/buick-logo.png',
  'GMC': 'https://www.carlogos.org/car-logos/gmc-logo.png',
  'Chrysler': 'https://www.carlogos.org/car-logos/chrysler-logo.png',
  'Mitsubishi': 'https://www.carlogos.org/car-logos/mitsubishi-logo.png',
  'Mini': 'https://www.carlogos.org/car-logos/mini-logo.png',
  'Alfa Romeo': 'https://www.carlogos.org/car-logos/alfa-romeo-logo.png',
  'Fiat': 'https://www.carlogos.org/car-logos/fiat-logo.png',
  'Skoda': 'https://www.carlogos.org/car-logos/skoda-logo.png',
  // New makes logos
  'Opel': 'https://www.carlogos.org/car-logos/opel-logo.png',
  'Seat': 'https://www.carlogos.org/car-logos/seat-logo.png',
  'Peugeot': 'https://www.carlogos.org/car-logos/peugeot-logo.png',
  'Citroen': 'https://www.carlogos.org/car-logos/citroen-logo.png',
};

export const carModels: Record<string, string[]> = {
  'Toyota': ['Corolla', 'Camry', 'RAV4', 'Highlander', 'Land Cruiser', 'Prius', 'Tacoma', 'Tundra', 'Yaris', 'Avalon'],
  'Honda': ['Civic', 'Accord', 'CR-V', 'Pilot', 'HR-V', 'Odyssey', 'Fit', 'Ridgeline', 'Insight'],
  'Hyundai': ['Elantra', 'Sonata', 'Tucson', 'Santa Fe', 'Kona', 'Palisade', 'Venue', 'Accent', 'Ioniq', 'Verna'],
  'Kia': ['Optima', 'Forte', 'Sportage', 'Sorento', 'Soul', 'Telluride', 'Seltos', 'Rio', 'Stinger', 'Carnival', 'Cerato', 'Morning'],
  'Mazda': ['Mazda3', 'Mazda6', 'CX-5', 'CX-9', 'MX-5', 'CX-3', 'CX-30', 'CX-50'],
  'Nissan': ['Altima', 'Maxima', 'Rogue', 'Murano', 'Pathfinder', 'Sentra', 'Versa', 'Armada', 'Kicks', 'Frontier'],
  'Mercedes-Benz': ['A-Class', 'C-Class', 'E-Class', 'S-Class', 'GLC', 'GLE', 'GLS', 'G-Class', 'CLA', 'GLB'],
  'BMW': ['3 Series', '5 Series', '7 Series', 'X3', 'X5', 'X1', 'X7', 'i4', 'iX', '4 Series', '2 Series'],
  'Audi': ['A3', 'A4', 'A6', 'Q5', 'Q7', 'e-tron', 'Q3', 'A5', 'Q8', 'A8', 'TT'],
  'Volkswagen': ['Golf', 'Jetta', 'Passat', 'Tiguan', 'Atlas', 'ID.4', 'Taos', 'Arteon', 'Polo', 'Caddy'], // Added Caddy
  'Ford': ['F-150', 'Mustang', 'Explorer', 'Escape', 'Edge', 'Bronco', 'Maverick', 'Ranger', 'Expedition'],
  'Chevrolet': ['Silverado', 'Equinox', 'Malibu', 'Tahoe', 'Traverse', 'Camaro', 'Suburban', 'Trax', 'Blazer'],
  'Jeep': ['Wrangler', 'Cherokee', 'Grand Cherokee', 'Compass', 'Renegade', 'Gladiator', 'Wagoneer'],
  'Dodge': ['Charger', 'Challenger', 'Durango', 'Journey', 'Hornet'],
  'Ram': ['1500', '2500', '3500', 'ProMaster', 'ProMaster City'],
  'Subaru': ['Outback', 'Forester', 'Crosstrek', 'Impreza', 'Legacy', 'Ascent', 'WRX', 'BRZ'],
  'Lexus': ['RX', 'ES', 'NX', 'IS', 'GX', 'UX', 'LS', 'LC', 'LX'],
  'Acura': ['MDX', 'RDX', 'TLX', 'ILX', 'NSX', 'Integra'],
  'Infiniti': ['Q50', 'QX60', 'QX80', 'QX50', 'Q60'],
  'Genesis': ['G70', 'G80', 'G90', 'GV70', 'GV80'],
  'Tesla': ['Model 3', 'Model Y', 'Model S', 'Model X', 'Cybertruck'],
  'Volvo': ['XC90', 'XC60', 'S60', 'V60', 'XC40', 'S90'],
  'Land Rover': ['Range Rover', 'Discovery', 'Defender', 'Range Rover Sport', 'Range Rover Evoque'],
  'Jaguar': ['F-Pace', 'E-Pace', 'I-Pace', 'XF', 'XE', 'F-Type'],
  'Porsche': ['911', 'Cayenne', 'Macan', 'Panamera', 'Taycan', '718 Cayman', '718 Boxster'],
  'Ferrari': ['Roma', 'Portofino', 'F8', 'SF90', '812 Superfast'],
  'Lamborghini': ['Urus', 'Aventador', 'Huracan'],
  'Maserati': ['Ghibli', 'Levante', 'Quattroporte'],
  'Bentley': ['Continental GT', 'Bentayga', 'Flying Spur'],
  'Cadillac': ['Escalade', 'XT5', 'CT5', 'XT4', 'CT4', 'XT6'],
  'Lincoln': ['Navigator', 'Aviator', 'Corsair', 'Nautilus'],
  'Buick': ['Enclave', 'Encore', 'Envision'],
  'GMC': ['Sierra', 'Terrain', 'Acadia', 'Yukon', 'Canyon'],
  'Chrysler': ['300', 'Pacifica', 'Voyager'],
  'Mitsubishi': ['Outlander', 'Eclipse Cross', 'ASX', 'Pajero', 'Lancer'],
  'Mini': ['Cooper', 'Clubman', 'Countryman', 'Convertible'],
  'Alfa Romeo': ['Giulia', 'Stelvio', 'Giulietta'],
  'Fiat': ['500', 'Panda', 'Tipo', 'Punto'],
  'Skoda': ['Octavia', 'Superb', 'Kodiaq', 'Karoq', 'Fabia', 'Scala', 'Kamiq', 'Rapid', 'Enyaq'],
  // New makes and their common models
  'Opel': ['Astra', 'Corsa', 'Insignia', 'Mokka', 'Grandland', 'Crossland', 'Zafira', 'Combo', 'Meriva', 'Vectra', 'Signum', 'Adam'],
  'Seat': ['Ibiza', 'Leon', 'Arona', 'Ateca', 'Toledo', 'Altea', 'Alhambra', 'Tarraco', 'Mii', 'Cordoba', 'Exeo'],
  'Peugeot': ['208', '308', '3008', '2008', '5008', '508', '206', '207', '307', '405', 'Partner', 'Expert', 'Traveller', 'Rifter'], // Added Rifter
  'Citroen': ['C3', 'C4', 'Berlingo', 'C5', 'C1', 'C2', 'C-Elysee', 'C4 Picasso', 'C5 Aircross', 'DS3', 'DS4', 'DS5'],
};

// Default models for undefined makes
carMakes.forEach(make => {
  if (!carModels[make]) {
    carModels[make] = ['Base Model', 'Sport', 'Premium', 'Luxury', 'Limited'];
  }
});

export const years = Array.from({ length: 30 }, (_, i) => 2024 - i);

export const engineTypes = [
  '4-cylinder', 
  '6-cylinder', 
  '8-cylinder', 
  'Hybrid', 
  'Electric', 
  'Diesel', 
  'Turbo 4-cylinder',
  'Twin-Turbo V6',
  'V8',
  'Inline-6',
  'Rotary',
  // Added more engine sizes as requested
  '1.2',
  '1.6',
  '1.8',
  '1.9',
  '2.0',
];

